import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import type { ReactNode } from "react";

import { SearchIcon } from "../../../../../assets/icons";
import {
  ActionButton,
  DetailsActions,
  Toggle,
} from "../../../components/global";

type Props = {
  title: ReactNode;
  hideRevoked: boolean;
  isSavingDocument: boolean;
  onToggleHideRevoked: () => void;
  onOpenFindBar: () => void;
  onSaveDocument: () => void;
  onPrint: () => void;
};

const LegislationDetailsHeaderActions = ({
  title,
  hideRevoked,
  isSavingDocument,
  onToggleHideRevoked,
  onOpenFindBar,
  onSaveDocument,
  onPrint,
}: Props) => {
  const renderActions = ({ hideLabelOnMobile = false } = {}) => (
    <>
      <Toggle
        label="Texto compilado"
        checked={hideRevoked}
        onChange={onToggleHideRevoked}
      />
      <ActionButton
        icon={<SearchIcon />}
        label="Buscar"
        onClick={onOpenFindBar}
        title="Abrir busca customizada (Ctrl+F)"
        hideLabelOnMobile={hideLabelOnMobile}
      />
      <ActionButton
        icon={<BookmarkBorderOutlinedIcon fontSize="small" />}
        onClick={onSaveDocument}
        disabled={isSavingDocument}
        label={isSavingDocument ? "Salvando..." : "Salvar"}
        hideLabelOnMobile={hideLabelOnMobile}
      />

      <ActionButton
        icon={<PrintOutlinedIcon fontSize="small" />}
        label="Imprimir"
        onClick={onPrint}
        hideLabelOnMobile={hideLabelOnMobile}
      />
    </>
  );

  return (
    <DetailsActions
      title={title}
      renderActions={renderActions}
      wrapStickyWithContainer={false}
    />
  );
};

export default LegislationDetailsHeaderActions;
